"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteConfToColorScheme = exports.sectionToColorScheme = exports.isEmptyColorScheme = exports.getSectionsListCss = exports.getSectionCss = exports.getSectionAtomValues = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _sectionElementsUtils = require("../sectionElementsUtils");

var _TemplatesConfig = _interopRequireDefault(require("../../TemplatesConfig"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mergeAtomRules = function mergeAtomRules(defaultAtomsStylesList, customizationAtomsStylesList) {
  return (0, _underscore.default)(defaultAtomsStylesList).map(function (defaultAtomsStyle, type) {
    return {
      atom: type,
      properties: _objectSpread(_objectSpread({}, defaultAtomsStyle), (customizationAtomsStylesList || {})[type] || {})
    };
  });
};

var siteConfToColorScheme = function siteConfToColorScheme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      color0 = _ref.color0,
      color1 = _ref.color1,
      color2 = _ref.color2,
      color3 = _ref.color3,
      color4 = _ref.color4,
      color5 = _ref.color5;

  return {
    color0: color0,
    color1: color1,
    color2: color2,
    color3: color3,
    color4: color4,
    color5: color5
  };
};

exports.siteConfToColorScheme = siteConfToColorScheme;
var sectionToColorScheme = siteConfToColorScheme;
exports.sectionToColorScheme = sectionToColorScheme;

var isEmptyColorScheme = function isEmptyColorScheme(_ref2) {
  var color0 = _ref2.color0,
      color1 = _ref2.color1,
      color2 = _ref2.color2,
      color3 = _ref2.color3,
      color4 = _ref2.color4,
      color5 = _ref2.color5;
  return !color0 && !color1 && !color2 && !color3 && !color4 && !color5;
};

exports.isEmptyColorScheme = isEmptyColorScheme;

var mergeColorSchemes = function mergeColorSchemes(sch0, sch1) {
  return _objectSpread(_objectSpread({}, _underscore.default.pick(sch0, function (value) {
    return value;
  })), _underscore.default.pick(sch1, function (value) {
    return value;
  }));
};

var propertyRenderers = {
  backgroundColor: function backgroundColor(value) {
    return "background-color: ".concat(value);
  },
  color: function color(value) {
    return "color: ".concat(value);
  },
  borderColor: function borderColor(value) {
    return "border-color: ".concat(value);
  }
};

var renderProperty = function renderProperty(propValue, propName) {
  if (propValue === null || propValue === undefined) {
    return null;
  }

  var renderer = propertyRenderers[propName];
  return renderer ? renderer(propValue) : null;
};

var renderSelector = function renderSelector(sectionUnique, elementUnique, atom) {
  if (elementUnique) {
    return ".section-".concat(sectionUnique, " .element-").concat(elementUnique, " .atom-").concat(atom);
  } else {
    return ".section-".concat(sectionUnique, " .atom-").concat(atom);
  }
};

var renderAtomRuleAsCss = function renderAtomRuleAsCss(_ref3) {
  var sectionUnique = _ref3.sectionUnique,
      elementUnique = _ref3.elementUnique,
      atom = _ref3.atom,
      properties = _ref3.properties;
  var cssProps = (0, _underscore.default)(properties).map(renderProperty).filter(_underscore.default.identity).join('; ');
  var selector = renderSelector(sectionUnique, elementUnique, atom);
  return "".concat(selector, " { ").concat(cssProps, "; }");
};

var renderRulesAsCss = function renderRulesAsCss(_ref4) {
  var sectionUnique = _ref4.sectionUnique,
      elementUnique = _ref4.elementUnique,
      atomRules = _ref4.atomRules;
  return atomRules.map(function (atomRule) {
    return renderAtomRuleAsCss(_objectSpread(_objectSpread({}, atomRule), {}, {
      sectionUnique: sectionUnique,
      elementUnique: elementUnique
    }));
  }).filter(_underscore.default.identity).join('\n');
};

var filterOnlyExistingAtoms = function filterOnlyExistingAtoms(defaults, customization) {
  var safeCustomization = customization || {};
  return (0, _underscore.default)(defaults || {}).chain().map(function (defProps, atomName) {
    var custProps = safeCustomization[atomName];
    var filteredProps = custProps ? _underscore.default.pick(custProps, Object.keys(defProps)) : null;
    return [atomName, filteredProps];
  }).object().value();
};

var getElementRules = function getElementRules() {
  var atomValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var section = arguments.length > 1 ? arguments[1] : undefined;
  var element = arguments.length > 2 ? arguments[2] : undefined;

  if (element.parent && atomValues[element.parent]) {
    atomValues = atomValues[element.parent]._elements || {};
  }

  var defaultAtomsStylesList = atomValues[element.type] || {};
  var customizationAtomsStylesList = filterOnlyExistingAtoms(defaultAtomsStylesList, element.customization);
  return {
    sectionId: section.id,
    sectionUnique: section.rootKey,
    elementId: element.id,
    elementUnique: element.rootKey,
    atomRules: mergeAtomRules(defaultAtomsStylesList, customizationAtomsStylesList)
  };
};

var getSectionRules = function getSectionRules() {
  var atomValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var section = arguments.length > 1 ? arguments[1] : undefined;
  var defaultAtomsStylesList = atomValues._section || {};
  var customizationAtomsStylesList = filterOnlyExistingAtoms(defaultAtomsStylesList, section.customization);
  return {
    template: section.template,
    sectionId: section.id,
    sectionUnique: section.rootKey,
    atomRules: mergeAtomRules(defaultAtomsStylesList, customizationAtomsStylesList)
  };
};

var getSectionAtomValues = function getSectionAtomValues(structure, siteConf, template, section) {
  var siteConfColorScheme = siteConfToColorScheme(siteConf);
  var sectionColorScheme = sectionToColorScheme(section);
  var colorScheme = mergeColorSchemes(siteConfColorScheme, sectionColorScheme);
  var selectedStructure = structure[template] || structure.common;

  if (!selectedStructure) {
    return {};
  }

  var templateStructure = selectedStructure({
    colorScheme: colorScheme
  }) || {};
  var sectionStructure = templateStructure[section.type];

  if (!sectionStructure) {
    templateStructure = structure.common({
      colorScheme: colorScheme
    } || {});
    sectionStructure = templateStructure[section.type];
  }

  return sectionStructure || {};
};

exports.getSectionAtomValues = getSectionAtomValues;

var getSectionCss = function getSectionCss(structure, siteConf, template, section) {
  var atomValues = getSectionAtomValues(structure, siteConf, template, section);
  var sectionRules = getSectionRules(atomValues, section);
  var elementsRules = (0, _sectionElementsUtils.flattenElementsJson)(section.elements).map(function (element) {
    return getElementRules(atomValues, section, element);
  });
  var sectionCss = renderRulesAsCss(sectionRules);
  var elementsCss = elementsRules.map(renderRulesAsCss).join('\n');
  return [sectionCss, elementsCss].join('\n');
};

exports.getSectionCss = getSectionCss;

var getSectionsListCss = function getSectionsListCss(structure, siteConf, sectionsList) {
  var renderPreview = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var themes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var retVal = [];
  sectionsList.forEach(function (section) {
    retVal.push(getSectionCss(structure, siteConf, section.template, section));

    if (renderPreview) {
      var previewThemes = themes[section.type] || _TemplatesConfig.default.templates.filter(function (t) {
        return !t.hidden;
      }).map(function (_ref5) {
        var name = _ref5.name;
        return name;
      });

      previewThemes.forEach(function (name) {
        var previewSection = _objectSpread(_objectSpread({}, section), {}, {
          rootKey: "".concat(section.rootKey, "-").concat(name),
          template: name
        });

        retVal.push(getSectionCss(structure, siteConf, name, previewSection));
      });

      var previewSection = _objectSpread(_objectSpread({}, section), {}, {
        rootKey: "".concat(section.rootKey, "-").concat(section.template)
      });

      retVal.push(getSectionCss(structure, siteConf, section.template, previewSection));
    }
  });
  return retVal.join('\n');
};

exports.getSectionsListCss = getSectionsListCss;